import React, { useState } from "react";
import { MdDelete } from "react-icons/md";
import { Constant } from "../../../../helper/constant";
import { useNavigate } from "react-router-dom";
import { formatRupiah } from "../../../../helper/formatNumber";

import "./inputPrescriptionTransaction.css";

const InputPrescriptionTransaction = ({
  prescriptionTransactionData,
  setPrescriptionTransactionData,
  isPartnerPrescription,
}) => {
  // =====================
  // Constant
  // =====================

  const navigate = useNavigate();
  const [SuggestionProduct, setSuggestionProduct] = useState([]);
  const [activeInputIndex, setActiveInputIndex] = useState(null);

  // =====================
  // Method
  // =====================

  const addPrescriptionProduct = () => {
    setPrescriptionTransactionData((prevData) => [
      ...prevData,
      {
        product_id: "",
        product_name: "",
        product_quantity: "",
        product_display_price: "Rp 0",
        product_amount: 0,
        product_total_price: 0,
        product_buying_price: 0,
        is_prescription: true,
      },
    ]);
    setSuggestionProduct([]);
  };

  const removeProduct = (index) => {
    setPrescriptionTransactionData((prevData) =>
      prevData.filter((_, i) => i !== index)
    );
  };

  const resetProductRowByIndex = (index) => {
    setPrescriptionTransactionData((prevProduct) => prevProduct.map((product, idx) => {
      if (idx === index) {
        return {
          product_id: "",
          product_name: "",
          product_quantity: "",
          product_display_price: "Rp 0",
          product_amount: 0,
          product_total_price: 0,
          product_buying_price: 0,
          is_prescription: false,
        }
      } else {
        return product
      }
    }))
  }

  const handleInputChange = (index, field, value) => {
    if (field === "product_name") {
      if (!value) {
        // check if `product_name` value is empty, then reset all field values
        resetProductRowByIndex(index)
        return
      }

      checkProductAutoComplete(value);
      setPrescriptionTransactionData((prevData) =>
        prevData.map((product, i) =>
          i === index ? { ...product, [field]: value } : product
        )
      );
    } else if (field === "product_quantity") {
      const quantity = parseFloat(value) || 0;
      const pricePerQuantity =
        prescriptionTransactionData[index].product_amount;

      const totalPricePerProduct = quantity * pricePerQuantity;
      const formattedPrice = isNaN(totalPricePerProduct)
        ? "Rp 0"
        : formatToIDR(totalPricePerProduct);

      setPrescriptionTransactionData((prevData) =>
        prevData.map((product, i) =>
          i === index
            ? {
              ...product,
              product_quantity: value,
              product_display_price: formattedPrice,
              product_total_price: totalPricePerProduct,
            }
            : product
        )
      );
    }
  };

  const checkProductAutoComplete = (keyword) => {
    if (keyword.length > 1) {
      findProduct(keyword);
    } else {
      setSuggestionProduct([]);
    }
  };

  const updateProductData = (index, newProduct) => {
    const initialQtyItem = "1"
    const priceItem = isPartnerPrescription ? newProduct.product_partner_selling_price : newProduct.product_hjr
    const totalPricePerItem = priceItem * parseFloat(initialQtyItem)

    setPrescriptionTransactionData((prevData) =>
      prevData.map((product, i) =>
        i === index
          ? {
            ...product,
            product_id: newProduct.product_id,
            product_name: newProduct.product_name,
            product_quantity: initialQtyItem,
            product_display_price: formatToIDR(priceItem),
            product_amount: priceItem,
            product_buying_price: newProduct.product_buying_price,
            product_total_price: totalPricePerItem,

            is_prescription: true,
          }
          : product
      )
    );
  };

  const formatToIDR = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    })
      .format(number)
      .replace(/\D00(?=\D*$)/, ""); // remove decimals
  };

  // =====================
  // Request Method
  // =====================

  const findProduct = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/produk/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionProduct(data.product);
    } catch (error) {
      setSuggestionProduct([]);
    }
  };

  return (
    <div className="input-product-transaction-container">
      <div className="input-list-product-titles">
        <span>Nama Produk</span>
        <span>Kuantitas</span>
        <span>Harga Satuan</span>
        <span>Total Harga</span>
      </div>
      {prescriptionTransactionData.map((product, index) => (
        <div className="input-list-product-container" key={index}>
          <input
            className="input-field-product"
            type="text"
            value={product.product_name ? product.product_name : ""}
            onChange={(e) =>
              handleInputChange(index, "product_name", e.target.value)
            }
            onFocus={() => {
              setActiveInputIndex(index);
              setSuggestionProduct([]);
            }}
            placeholder="Masukkan nama produk"
          />

          <input
            className="input-field-product"
            type="text"
            value={product.product_quantity ? product.product_quantity : ""}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
            onChange={(e) =>
              handleInputChange(index, "product_quantity", e.target.value)
            }
            onFocus={() => setActiveInputIndex(null)}
            placeholder="Masukkan kuantitas product"
          />
          <input
            className="input-field-product"
            type="text"
            value={
              product.product_amount ? formatRupiah(product.product_amount) : ""
            }
            onChange={() => { }}
            placeholder="Harga satuan Barang"
            disabled={true}
          />
          <input
            className="input-field-product"
            type="text"
            value={
              product.product_display_price ? product.product_display_price : ""
            }
            onChange={() => { }}
            placeholder="Harga Barang"
            disabled={true}
          />
          {prescriptionTransactionData.length > 1 && (
            <MdDelete
              className="remove-product-list"
              onClick={() => {
                removeProduct(index);
              }}
            />
          )}
          {SuggestionProduct.length > 0 && activeInputIndex === index && (
            <ul className="dropdown-list-product-transaction">
              {SuggestionProduct.map((products) => (
                <li key={products.product_id}>
                  <button
                    className="dropdown-button"
                    onClick={() => {
                      updateProductData(activeInputIndex, products);
                      setSuggestionProduct([]);
                    }}
                  >
                    {products.product_name} | Stok Sisa:{" "}
                    <b>{products.product_total_stock}</b> | Harga Satuan:{" "}
                    <b>
                      {formatToIDR(
                        isPartnerPrescription
                          ? products.product_partner_selling_price
                          : products.product_hjr
                      )}
                    </b>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
      <button
        className="add-more-product-item"
        type="button"
        onClick={addPrescriptionProduct}
      >
        Tambah Resep Lagi
      </button>
    </div>
  );
};

export default InputPrescriptionTransaction;
